<template>
<Card>
    <template #content>
		<p>Los pagos han sido procesados con éxito. Si desea enviar comprobantes a los correos electrónicos registrados presiones el botón de "Enviar".</p>
        <Divider />      		    
        <DataTable :value="pagos" editMode="cell" dataKey="rec.id_movimiento" v-model:selection="selectedPagos" :rowClass="rowClass" v-model:expandedRows="expandedRows" responsiveLayout="scroll" class="p-datatable-sm"
		filterDisplay="menu" :rowSelectable="isRowSelectable">
			<template #header>        
				<div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
					<div class="p-input-icon-right">
						<Button label="Enviar y Finalizar" icon="pi pi-envelope" class="p-button-secondary" @click="dlgEnvioEmail=true" :disabled="!puedeEnviarEmails"/>
					</div>
					<div class="p-input-icon-right">
						<Button label="Finalizar" icon="pi pi-check" class="p-button-success" @click="finalizar"/>
					</div>		
				</div>
			</template>		
			<template #empty>
				No hay pagos procesados
			</template>		
            <Column selectionMode="multiple" headerStyle="width: 3rem"/>
			<Column field="tipo_movimiento" header="Tipo">
				<template #body="slotProps">
					<div v-if="slotProps.data.error" style="font-weight: 700;color: #FF5252;" class="p-d-flex p-ai-center">ERROR</div>
					<div v-else>{{slotProps.data.rec.tipo_movimiento}}</div>
				</template>
			</Column>				
			<Column field="serie" header="Doc #"> 
				<template #body="slotProps">
                   	<div class="p-d-flex p-jc-start">
						<div v-if="slotProps.data.error" style="font-weight: 700;color: #FF5252;" class="p-d-flex p-ai-center"></div>						
                        <div v-else>{{slotProps.data.serie}}-{{slotProps.data.rec.no_docto}}</div>
                    </div>                									
				</template>					
			</Column>
            <Column field="cta_habiente" :header="tituloCtaHabiente">       
				<template #body="slotProps">
                    <div v-if="slotProps.data.error" style="font-weight: 700;color: #FF5252;" class="p-d-flex p-ai-center">{{slotProps.data.cta_habiente}}</div>
					<div v-else>{{slotProps.data.cta_habiente}}</div>
				</template>
			</Column>			
			<Column field="rec.referencia" header="Referencia">
				<template #body="slotProps">
                    <div v-if="slotProps.data.error" style="font-weight: 700;color: #FF5252;" class="p-d-flex p-ai-center">{{slotProps.data.err_msg}}</div>
					<div v-else>{{slotProps.data.rec.referencia}}</div>
				</template>			
			</Column>
            <Column field="rec.total" header="Total"> 
				<template #body="slotProps">
                   	<div class="p-d-flex p-jc-end">
                    	{{slotProps.data.rec.id_moneda}} {{formatCurrency(slotProps.data.rec.total)}}
                    </div>                									
				</template>
			</Column>	
			<ColumnGroup type="footer">
				<Row>
					<Column footer="Documentos:" :colspan="4" footerStyle="text-align:right" />
					<Column :footer="totalTrxAEmitir" />
					<Column :footer="montoTotalAOperar" :colspan="3" footerStyle="text-align:right" />
				</Row>
			</ColumnGroup>					
        </DataTable>				
    </template>
    <template #footer>        
        <!-- <div class="p-d-flex p-jc-between">
            <Button label="Enviar" @click="Enviar" class="p-button-warning" icon="pi pi-cog" v-show="!errores" :disabled="totalTrxAEmitir==0"/>
        </div> -->
    </template>
</Card>

<Dialog v-model:visible="dlgEnvioEmail" :modal="true">
	<template #header>
		Confirmación de envío de notificación
	</template>
	<div class="p-d-flex">
		<i class="pi pi-envelope p-mr-2" style="fontSize: 2rem"></i>
		<p>¿Está seguro que desea enviar los comprobantes seleccionado(s)?</p>
	</div>
	<template #footer>
		<div class="p-field p-col">
			<Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="dlgEnvioEmail=false"/>
			<Button label="Enviar" icon="pi pi-send" class="p-button-text" @click="enviarACtahabientesSeleccionados"/>
		</div>
	</template>
</Dialog>	

<Dialog v-model:visible="enviandoEmailsDlg" :showHeader="true" :modal="true" :closable="false">			
	<div class="flex align-content-center flex-wrap card-container" :style="{width: '500px', height: '250'}">
		<div class="p-d-flex p-ai-center p-jc-center">
			<!-- <i class="pi pi-send p-m-2" style="font-size: 2rem"></i> -->
			<img src="/assets/layout/images/message.gif" width="64" height="64"/>
		</div>
		<div class="flex align-items-center justify-content-center mt-5">				
		<ProgressBar :value="secuencia">										
			<div class="font-light">
			Enviando {{secuencia}} de {{selectedPagos.length}}
			</div>
		</ProgressBar>
		</div>
	</div>
</Dialog>


</template>
<script>
import { CURRENT_APP_MODE, MDS_APP_MODE} from '../../service/constants';
import CxcService from '../../service/cxc.service';
import MdsService from '../../service/mds.service';
import InvService from '../../service/inv.service';
import Divider from 'primevue/divider';

export default {
    name: 'CxcImpResumen',
	emits: ['prevPage', 'nextPage', 'complete'],		
    components: {
        Divider
    },    
	props: {
		formData: {
			type: Object,
			Default() {
				return {
					id_perfil: '',
					id_moneda: '',
					archivo: '',
					errores: false,
					movs: [],					
				}
			}
		}
	},          
    data() {        
        return {         
            appMode: CURRENT_APP_MODE,
			tituloCtaHabiente: (CURRENT_APP_MODE == MDS_APP_MODE? 'Inmueble': 'Cta.Habiente'),
			secuencia: 1,
			procesandoDlg: false,
			id_moneda: this.formData.id_moneda,
			errores: this.formData.errores,
			pagos: this.formData.movs,
			selectedPagos: [],
			dataRefresh: 0,
			gran_total: 0.0,
            dlgEnvioEmail: false,
			enviandoEmailsDlg: false,
			expandedRows: [],
        }
    },
    async mounted()
    {
		this.gran_total = 0;
		for(var i = 0; i < this.pagos.length; i++)
		{
			if(!this.pagos[i].error) {
				this.gran_total = this.gran_total + this.pagos[i].rec.total;			
			}
		}
		
    },
	computed:{
		totalTrxAEmitir()
		{
			if(this.pagos) {
				var totalEmitidos = this.pagos.filter(p=> !p.error).length;
				return totalEmitidos;
				// return this.pagos.length;
			} else {
				return 0;
			}
		},
		montoTotalAOperar()
		{
			return `Total: ${this.id_moneda} ${this.formatCurrency(this.gran_total)}`;
		},
		puedeEnviarEmails() {
			if(this.selectedPagos) {
				return (this.selectedPagos.length > 0)
			}  else {
				return false;
			}
		}        		
	},    
    methods: {
        finalizar() {
			this.$router.push('/');
		},
		
		isRowSelectable(Event) {			
			console.log(JSON.stringify(Event));
			var rowData = Event.data;
			console.log(JSON.stringify(rowData));
			return !rowData.error;
			// return event.data.enabled !== false;
		},
		
		async enviarACtahabientesSeleccionados()
		{
			this.dlgEnvioEmail	= false;
			try
			{
				this.enviandoEmailsDlg = true;
				this.secuencia = 1;
				var notif;

				for(var i = 0; i < this.selectedPagos.length; i++)
				{	
					if(this.selectedPagos[i].error) {
						continue;
					};

					notif = {						
						id: this.selectedPagos[i].rec.id_movimiento,
						emails: []
					};

					if(this.appMode == MDS_APP_MODE) { // Multidomus
						notif.emails =  await MdsService.getInmueblesEmailsNotificacion(this.$store.state.auth.currentAppCtx, this.selectedPagos[i].rec.id_cta_habiente_info);
					} else {
						notif.emails = await InvService.getCtaHabienteEmailsNotificacion(this.$store.state.auth.currentAppCtx, this.selectedPagos[i].rec.id_cta_habiente_info);
					}

					if(notif.emails.length > 0) {
						await CxcService.enviarEmailTrx(this.$store.state.auth.currentAppCtx, notif);
					}
					
					this.secuencia++;
				}
				this.secuencia = 1;
				this.enviandoEmailsDlg = false;
				this.finalizar();
			}
			catch(error) {
				this.dlgEnvioEmail = false;
				console.log(error);
			}
		},
        onRowSelect(data) {
            data.aplicar = !data.aplicar;				
			return data.aplicar;			
        },
		rowClass(data)
		{
			var className = (data.emitir?"emitir-row":"regular-row");
			return className;
		},
		findIndexMovimiento(idMovimiento)
		{
			var index = -1;
			for(var i=0; i<this.pagos.length; i++)
			if(this.pagos[i].id_movimiento === idMovimiento) {
				index = i;
				break;
			}

			return index;
		},
		formatCurrency(value) {
			return parseFloat(value).toLocaleString('en-US', {minimumFractionDigits: 2});
		},	        
        prevPage() {
            this.$emit('prevPage', {pageIndex: 1});
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep(b) {
    display: block;
}

::v-deep(.p-card-body) {
    padding: 2rem;
}

::v-deep(.regular-row) {
	font-weight: 300;
	background: white;
}

::v-deep(.emitir-row) {
	font-weight: bold;
	background:white;
}

</style>